import { TableCell, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useState } from 'react';

function TextOverFlowToolTip({ text, capitalize = false}) {
  let textElementRef = null;
  const [tooltipEnabled, setTooltipEnabled] = useState(false);

  const getRefText = (ref) => {
    textElementRef = ref;
    if (textElementRef && text) {
      setTooltipEnabled(textElementRef.clientWidth < textElementRef.scrollWidth);
    }
  };

  return (
    <Tooltip
      disableHoverListener={!tooltipEnabled}
      disableTouchListener={!tooltipEnabled}
      title={text}
      arrow
    >
      <TableCell className="max-w-[100px]">
        <Typography
          ref={getRefText}
          class={`fs-12 ff-Roboto fw-regular table-td-overflow  ${capitalize ? '!capitalize' : ''}`}
        >
          {text || text === 0 ? text : '-'}
        </Typography>
      </TableCell>
    </Tooltip>
  );
}

export default TextOverFlowToolTip;
